import dayjs, { Dayjs } from 'dayjs';
import type { IClassroomPost } from 'components/classroom/EditClassroomForm';
import type { ITree } from 'interfaces/tree';

export const isClassroomPeriodClosed = (
  endsAt?: string | null,
  now: Dayjs = dayjs()
): boolean => !!endsAt && dayjs(endsAt).isBefore(now);

export const canEditClassroomCriteria = (
  edit: boolean,
  endsAt?: string | null,
  now: Dayjs = dayjs()
): boolean => !edit || !isClassroomPeriodClosed(endsAt, now);

export const parseClassroomFormValues = (
  values: IClassroomPost,
  contentTree?: ITree
): IClassroomPost => ({
  ...values,
  ...(contentTree ? { content_tree: contentTree } : {}),
  minimum_attendance: values.frequency_required
    ? values.minimum_attendance ?? null
    : null,
  minimum_progress_percentage: values.progress_required
    ? values.minimum_progress_percentage ?? null
    : null
});
